"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RestoringWidgetTitle = exports.RestoringWidget = exports.StyledContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styleConstants = require("@widget-editor/shared/lib/styles/style-constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledContainer",
  componentId: "bllszm-0"
})(["position:relative;display:flex;flex-shrink:1;flex-grow:1;flex-flow:column;background:#fff;flex:0 0 50%;width:50%;", " ", ""], function (props) {
  return props.compact && "\n    flex: 0 0 100%;\n    width: 100%;\n    ";
}, (0, _styleConstants.DEFAULT_BORDER)());

exports.StyledContainer = StyledContainer;

var RestoringWidget = _styledComponents["default"].div.withConfig({
  displayName: "style__RestoringWidget",
  componentId: "bllszm-1"
})(["height:300px;display:flex;align-items:center;justify-content:center;"]);

exports.RestoringWidget = RestoringWidget;

var RestoringWidgetTitle = _styledComponents["default"].h4.withConfig({
  displayName: "style__RestoringWidgetTitle",
  componentId: "bllszm-2"
})(["color:#a9a9a9;font-size:21px;"]);

exports.RestoringWidgetTitle = RestoringWidgetTitle;